import user from "../../../../assets/icons/user.svg";
import arrow from "../../../../assets/icons/arrow.svg";
import BarekamButton, { HeaderButtons } from "../../../components/button";
import { useState } from "react";
import { Menu } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { logOutAction } from "../../../../redux/slices/login-slice";
import { useNavigate } from "react-router-dom";
import { ButtonType } from "../header-button.enum";
import MobileUserButtons from "./blocks/mobile-user-buttons";
import DesktopUserButtons from "./blocks/desktop-user-buttons";
import { UserMenuImageItem, UserMenuNameItem } from "./styled";
import {
  BarekamIcon,
  IconVariants,
} from "../../../components/icon/barekam-icon";

const UserButton = ({
  hasValidatedRecipient,
  isDesktop,
  isTablet,
  isAdmin,
  isWarehouseWorker,
  isPdr,
}: UserButtonProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { matchesPhone } = useAppSelector((state) => state.deviceReducer);
  const { currentUser } = useAppSelector((state) => state.currentUserReducer);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const userMenuOpened = Boolean(anchorEl);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const openUserMenu = (event: MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleButtonClick = (button: ButtonType) => {
    resetAnchorEl();

    switch (button) {
      case ButtonType.MY_RECIPIENTS:
        navigate("user/settings#2");
        break;
      case ButtonType.ALL_USERS:
        navigate("user/all");
        break;
      case ButtonType.MY_ADDRESSES:
        navigate("user/my-addresses");
        break;
      case ButtonType.SET_MONTHLY_LIMITS:
        navigate("user/monthly-limits");
        break;
      case ButtonType.ACCOUNT_SETTINGS:
        isAdmin || isWarehouseWorker || isPdr
          ? navigate("management/user/settings#0")
          : navigate("user/settings#0");
        break;
      case ButtonType.WALLET:
        navigate("user/balance");
        break;
      case ButtonType.DELIVERY_ADDRESSES:
        navigate("user/settings#1");
        break;
      case ButtonType.LOG_OUT:
        dispatch(logOutAction());
        navigate("login");
        break;
    }
  };

  const resetAnchorEl = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <BarekamButton
        type={HeaderButtons.SIMPLE}
        onClick={(event) => openUserMenu(event)}
      >
        <img src={user} alt={"user"} />

        {matchesPhone ? "" : <img src={arrow} alt={"arrow"} />}
      </BarekamButton>

      <Menu
        open={userMenuOpened}
        anchorEl={anchorEl}
        onClose={() => resetAnchorEl()}
      >
        <UserMenuImageItem disabled>
          <BarekamIcon
            variant={IconVariants.user}
            size={{ width: "2rem", height: "2rem" }}
          />
        </UserMenuImageItem>

        <UserMenuNameItem disabled>
          <b>
            {currentUser?.firstName} {currentUser?.lastName}
          </b>
        </UserMenuNameItem>

        {isDesktop || isTablet ? (
          <DesktopUserButtons
            hasValidatedRecipient={hasValidatedRecipient}
            handleButtonClick={handleButtonClick}
            isAdmin={isAdmin}
            isWarehouseWorker={isWarehouseWorker}
            isPdr={isPdr}
          />
        ) : (
          <MobileUserButtons
            hasValidatedRecipient={hasValidatedRecipient}
            handleButtonClick={handleButtonClick}
            isAdmin={isAdmin}
            isWarehouseWorker={isWarehouseWorker}
            isPdr={isPdr}
          />
        )}
      </Menu>
    </>
  );
};

interface UserButtonProps {
  isAdmin: boolean;
  isWarehouseWorker: boolean;
  hasValidatedRecipient: boolean;
  isDesktop: boolean;
  isTablet: boolean;
  isPdr: boolean;
}

export default UserButton;
